var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-container"},[_c('div',{staticClass:"event-image-container",style:({
          backgroundImage: 'url(' + require(("@/assets/" + (_vm.player.image))) + ')'
      })}),_c('div',{staticClass:"event-text-container"},[_c('small',[_vm._v(_vm._s(_vm.order))]),_c('div',{staticClass:"event-title"},[_vm._v(_vm._s(_vm.player.name))]),_c('p',[_vm._v(_vm._s(_vm.player.mote))])])])}
var staticRenderFns = []

export { render, staticRenderFns }